import React, { Component } from 'react'
import { Button , Alert,Modal , Container,Col,Row } from 'react-bootstrap';
import serverPath from '../config';
import axios from 'axios';
import {connect} from 'react-redux'
import itemImg from '../../assets/img/default.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReasonForm from './ReasonForm'
import { faTrash ,faPen} from '@fortawesome/free-solid-svg-icons'
import SweetAlert from 'react-bootstrap-sweetalert';
import { Planets } from 'react-preloaders';
import SearchBar from '../layout/SearchBar'

class ReasonsList extends Component{
        state={
            reasons:[],
            showModal:false,
            typeModal:'',
            selectedId:'',
            selectedItem:'',
            errmsg:'',
            cerrmsg:'',
            show:'',
            alertDelete:'',
            alertSuccess:'',
            loading:true
    }
   async componentDidMount(){
    await axios.get(`${serverPath}/api/all_pre_define_reason`, {
        headers: {
            'Accept': 'application/json',
            'Authorization':'Bearer '+this.props.token
        }
    })
    .then((response) => {
        const reasons= response.data.data;
       this.setState({reasons,loading:false})
    },(error)=>{
        if(error.response.status === 403){
            this.props.history.push('/nopermission')
         }
        if(error.response){
            this.setState({cerrmsg : error.response.data.message,loading:false,show:true
            })  
        }
        else{
          this.setState({cerrmsg : null})
        }
      })
        const wrapper=document.querySelector(".buffet-wrapper")
        const offset=wrapper.offsetTop
        wrapper.style.height= 'calc(100vh - '+offset+'px - 40px)'

}
    handleShowModal=(type,id,item)=>{
        this.setState({showModal:true,typeModal:type,selectedId:id?id:'',selectedItem:item?item:''})
    }
    handleCloseModal=()=>{
        this.setState({showModal:false,typeModal:'',selectedId:'',errmsg:''})
    }
    handleCreate = (review)=>{
        let errmsg=this.state.errmsg
        errmsg='';

        const reasons = this.state.reasons;
        axios.post(`${serverPath}/api/create_pre_define_reason`,
           { review:review}
        ,{
            headers:{
                'Authorization':`Bearer ${this.props.token}`,
                'Accept': 'application/json',
            }
        }).then((response)=>{
            reasons.push(response.data.data)
            this.setState({reasons})
            this.setState({showModal:false})
            this.showAlertSuccess()
        }, (error) => {
            if (error.response) {
                error.response.data.errors.map(err => (errmsg += err + " . "))
                this.setState({show: true,errmsg})

            }
            else{
            this.setState({errmsg : null})
            }
        })
        
    }
    handleEdit = (review,id)=>{
        const reasons= this.state.reasons
        let errmsg = this.state.errmsg
        errmsg = '';
        axios.post(`${serverPath}/api/edit_pre_define_reason/`,
            {
                id:id,
                review:review
            }
        ,{
            headers:{
                'Authorization':`Bearer ${this.props.token}`,
                'Accept': 'application/json',
            }
        }).then((response)=>{
            this.setState({editModal:false})
            for (let i in reasons) {
                
                if (reasons[i].id == id) {
                    reasons[i]='';
                    reasons[i]=response.data.data
                break; //Stop this loop, we found it!

                }
                this.setState({reasons})
            } 
            this.setState({showModal:false})
            this.showAlertSuccess()

        }, (error) => {
            if (error.response) {
                error.response.data.errors.map(err => (errmsg += err + " . "))
                this.setState({show: true,errmsg})

            }
            else{
            this.setState({errmsg : null})
            }
        });
    }
    handleDelete=(id)=>{
        let errmsg = this.state.errmsg
        const headers=   {
            'Authorization':'Bearer '+this.props.token,
            'Accept':'application/json'
        }
       
        axios.post(`${serverPath}/api/delete_pre_define_reason`,{id:id}, {headers: headers}).then((response)=>{

            this.showAlertSuccess()

        }, (error) => {
            if (error.response) {
                error.response.data.errors.map(err => (errmsg += err + " . "))
                this.setState({show: true,errmsg})

            }
            else{
              this.setState({errmsg : null})
            }
          });
        const reasons = this.state.reasons.filter(reason=>{
            return reason.id !== id
        })
        this.setState({reasons,alertDelete:''})
    }  
    onCancel = ()=>{
        this.setState({alertDelete:''})
    }
    onCancelSuccess = ()=>{
        this.setState({alertSuccess:''})
    }
    showAlertSuccess=()=>{
        this.setState({
            alertSuccess:<SweetAlert
            success
            confirmBtnText="تم"
            confirmBtnBsStyle="primary"
            title="تم تنفيذ طلبك بنجاح !"
            timeout={2000}
            onConfirm={this.onCancelSuccess}
            onCancel={this.onCancelSuccess}
          >
          </SweetAlert>
        })
    }
    showAlertDelete=(id,reasonname)=>{
        this.setState({
            alertDelete:<SweetAlert
            danger
            showCancel
            confirmBtnText="حذف"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="primary"
            cancelBtnText='رجوع'
            title= {  ' هل انت متأكد من مسح ' + (reasonname) + ' ؟ '}
            onConfirm={()=>this.handleDelete(id)}
            onCancel={this.onCancel}
          >
          </SweetAlert>
        })
    }
    setShow = ()=>{
        const show = false
        this.setState({show,errmsg:''})
      }
    render(){
        const permissions=this.props.permissions;

        const reasons=this.state.reasons.length>0 ? this.state.reasons.map(reason=>{
            return(
                <li className='collection-item' key={reason.id}>
                       
                        <span>{reason.review}</span>
                       
                        <div className='record-control'>
                        {permissions
                                    ? (permissions.map((permission, index) => {
                                        return (permission === 'pre-reasons'
                                            ? (
                                                <Button  variant="success" onClick={()=>this.handleShowModal("edit",reason.id,reason)}><FontAwesomeIcon  icon={faPen}/></Button>

                                            )
                                            : (null))
                                    }))
                                    : null}
                        {permissions
                                    ? (permissions.map((permission, index) => {
                                        return (permission === 'pre-reasons'
                                            ? (
                                                <Button  variant="danger" onClick={()=>this.showAlertDelete(reason.id,reason.review)}><FontAwesomeIcon icon={faTrash}/></Button>

                                            )
                                            : (null))
                                    }))
                                    : null}
                        </div>
                   
                </li>
            )
        }):(<Col>لا توجد بيانات</Col>)
    
        return(
            <div className='page-content'>
                 <div className='page-header'>
                    <Container fluid>
                        <Row>
                        {permissions
                                ? (permissions.map((permission, index) => {
                                    return (permission === 'pre-reasons'
                                        ? (
                                            <Col xs={'auto'}>
                                                <Button key={index} variant="primary" onClick={()=>this.handleShowModal("add")}>أضف تقييم جديد</Button>
                                            </Col>
                                        )
                                        : (null))
                                }))
                                : null}
                            <Col>
                                <SearchBar/>
                            </Col>
                        </Row>
                    </Container>                   
                </div>
                <Container fluid>
                    <ul className='collection buffet-wrapper'>
                    <Planets customLoading={this.state.loading} />                
                        {reasons}
                    </ul>
                    <Modal animation={false} show={this.state.showModal} onHide={this.handleCloseModal}>
                    <Modal.Header closeButton>
                    <Modal.Title>
                    {this.state.typeModal == 'add' ? 'إضافة تقييم جديد':'تعديل تقييم'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ReasonForm 
                        type={this.state.typeModal}
                        reason={this.state.selectedItem} 
                        createReason={this.handleCreate} 
                        editReason={this.handleEdit} 
                        errmsg={this.state.errmsg}
                        show={this.state.show}
                        setShow={this.setShow}
                        />
                    </Modal.Body>
              
                </Modal>
                {this.state.cerrmsg ?(
                    
                    <Alert show={this.state.show} variant="danger" dismissible onClose={this.setShow}>
                    
                        <span className='cursor' onClick={this.handleLogout}>{this.state.cerrmsg}</span>
                    </Alert>) : null} 
                </Container>
                {this.state.alertDelete}
                  {this.state.alertSuccess}
            </div>
            
        )
    }
}
const mapStateToProps=(state)=>{
    return{
        token:state.auth.token,
        usertype:state.user.usertype,
        permissions:state.user.permissions


    }
}

export default connect(mapStateToProps) (ReasonsList)